<template>
  <div class="by-center">
    <div class="text-h6 my-8" id="title">{{ acquiring.data.entityTitle }}</div>

    <dl>
      <dt>
        <v-icon>mdi-phone</v-icon>
      </dt>
      <dd>{{ numberFormatted }}</dd>

      <dt class="mb-8">
        <v-icon>mdi-map-marker</v-icon>
      </dt>
      <dd>{{ acquiring.data.entityAddress }}</dd>

      <dt>ИНН</dt>
      <dd>{{acquiring.data.inn}}</dd>

      <dt>{{ ogrnTitle }}</dt>
      <dd>{{ ogrn }}</dd>

      <dt>Банк</dt>
      <dd>{{ acquiring.data.bank }}</dd>

      <dt>БИК</dt>
      <dd>{{ acquiring.data.bik }}</dd>

      <dt>К/с №</dt>
      <dd>{{ acquiring.data.numKS }}</dd>
      <dt>Р/с №</dt>
      <dd id="account">{{ acquiring.data.numRS }}</dd>
    </dl>
  </div>
</template>

<script>
import {getAcquiring} from '@/composables/acquiring'
import {formatPhoneNumber} from '../services/utils';

export default {
  name: 'AcquiringAbout',
  computed: {
    acquiring: getAcquiring,
    numberFormatted () {
      return formatPhoneNumber(this.acquiring.data.phone)
    },
    ogrn () {
      return this.acquiring.data.type === 'ip' ? this.acquiring.data.ogrnip : this.acquiring.data.ogrn;
    },
    ogrnTitle () {
      return this.acquiring.data.type === 'ip' ? 'ОГРНИП' : 'ОГРН';
    }
  }
}
</script>

<style scoped>
dl {
  display: grid;
  grid-template-columns: auto 1fr;
}
dt {
  font-weight: 500;
  min-width: 0;
  margin-bottom: .5em;
}
dd {
  margin: 0 0 1em 1em;
}
</style>